/*** IMPORTS FROM imports-loader ***/
var define = false;

import profileCardMasonry from '../util/profileCardMasonry';
import studentFilter from '../util/studentFilter';
import disciplineFilter from '../util/disciplineFilter';
import accordion from '../util/accordion';
import matchWidth from '../util/matchWidth';
import shapesParallax from '../util/shapesParallax';
import StickyHomeDisciplinesFilter from "../util/StickyHomeDisciplinesFilter";
import YearSelector from '../util/YearSelector';

export default {
  init() {
  },

  finalize() {
    accordion.init();
    matchWidth.init();
    profileCardMasonry.init('[data-profile-cards-list]');
    YearSelector.init();

    studentFilter();
    disciplineFilter();

    StickyHomeDisciplinesFilter.init('#home-disciplines-filter');

    shapesParallax.init();
  },
};

